<template>
  <div>
    <!-- <Header />
    Team Dashboard -->
    <!-- <div>
      <div>{{ splitTests }}</div>
      <div>Winning split tests</div>
    </div> -->
    <h3>New Releases</h3>
    <div :class="$style.block">
      <div v-for="(mr, index) in mergeRequests" :key="index" :class="$style.listItem">
        <div v-if="!mr.projectImage" :class="$style.icon"></div>
        <img v-if="mr.projectImage" :class="$style.iconNoBg" :src="mr.projectImage" />
        <div :class="$style.text">
          <div :class="$style.underline">
            <h3 :class="$style.projectName">{{mr.projectName}}</h3>
          </div>
          <div :class="$style.timestamp">{{ time(mr.timestamp) }}</div>
          <div :class="$style.title">{{ mr.title }}</div>
          <div :class="$style.desc">{{ mr.desc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import Header from '../lib/Header'
  import database from '../../database'
  export default {
    name: 'TeamDashboard',
    components: {
      Header
    },
    data () {
      return {
        splitTests: 13337,
        mergeRequests: []
      }
    },
    methods: {
      time (ts) {
        return moment(ts).fromNow()
      }
    },
    mounted () {
      database.bindOrder(['team', 'mergeRequests'], 'timestamp', 10, (snap) => {
        const vals = Object.values(snap.val())
        this.mergeRequests = vals.sort((a, b) => a.timestamp < b.timestamp)
      })
    }
  }
</script>

<style lang="scss" module>
@import '~@/style/settings.scss';

h3 {
  margin: 20px 0;
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  color: #222;
}
.block {
  // background-color: white;
  padding: 15px;
  font-family: 'Nunito', sans-serif;
}

.listItem {
  padding: 10px;
  margin-bottom: 10px;
  position: relative;

  .icon {
    position: absolute;
    height: 50px;
    width: 50px;
    left: 0;
    border-radius: 50%;
    background-color: #64DD17
  }

  .iconNoBg {
    position: absolute;
    height: 50px;
    width: 50px;
    left: 0;
    border-radius: 50%;
  }

  .text {
    margin-left: 60px;
  }

  .timestamp {
    font-size: .9em;
    // color: $gray;
  }

  .projectName {
    margin-bottom: 0.3em;
  }

  .underline {
    border-bottom: 2px solid #0095F7;
    width: 30%;
    margin-bottom: 0.5em;
  }

  .title {
    font-weight: 700;
    font-size: 1.3em;
    letter-spacing: -0.03em;
    margin-bottom: 5px;
    color: #111
  }
  .desc {
    line-height: 1.6em;
    color: #607D8B;
    font-size: 1em;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TeamDashboard/index.vue